/*
  单个 VIP 的数据内容
*/

export default {
  state: {
    id: null,
    name: undefined,
    detail: undefined,
    contains: [],
    cashNeeded: null,
    creditsAwarded: null,
    validPeriod: null,
    expiredAt: undefined,
    expired: true,
    videosCount: null,
    coursesCount: null,
    fontsCount: null
  },
  mutations: {
    UPDATE_VIP (state, vip) {
      ['id', 'name', 'detail', 'contains', 'cashNeeded', 'creditsAwarded', 'validPeriod', 'expiredAt', 'expired', 'videosCount', 'coursesCount', 'fontsCount'].forEach(key => {
        state[key] = vip[key]
      })
    }
  },
  actions: {
    updateVip ({ commit }, vip) {
      commit('UPDATE_VIP', vip)
    }
  }
}
